import { render, staticRenderFns } from "./estimates-edit.vue?vue&type=template&id=865bbe6a&scoped=true"
import script from "./estimates-edit.vue?vue&type=script&lang=js"
export * from "./estimates-edit.vue?vue&type=script&lang=js"
import style0 from "./estimates-edit.vue?vue&type=style&index=0&id=865bbe6a&prod&lang=css"
import style1 from "./estimates-edit.vue?vue&type=style&index=1&id=865bbe6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865bbe6a",
  null
  
)

export default component.exports